import { withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { PageSection } from 'Components/Layout';
import {
  WorksheetImagesAndRemarksSection,
  WorksheetRootComponent,
  WorksheetTestedBySection,
} from 'Components/Worksheets/Core';
import ids from 'Components/Worksheets/QestIds';
import { MeasurementsSection, PreparationSection, ResultsSection } from '../Shared';

let BsEnMoistureConditionValueWorksheet: WorksheetRootComponent = () => {
  return (
    <>
      <PageSection heading="Preparation">
        <PreparationSection />
      </PageSection>

      <PageSection heading="Moisture Condition Value Measurements">
        <MeasurementsSection />
      </PageSection>

      <PageSection>
        <WorksheetTestedBySection />
      </PageSection>

      <PageSection heading="Results">
        <ResultsSection chartNamePrefix="mcvChart" />
      </PageSection>

      <PageSection heading="Images and Remarks">
        <WorksheetImagesAndRemarksSection />
      </PageSection>
    </>
  );
};

BsEnMoistureConditionValueWorksheet.qestIds = [ids.moistureConditionValue.BS_EN_13286_46.rev2003];
BsEnMoistureConditionValueWorksheet = withInjectedProps(BsEnMoistureConditionValueWorksheet);

export { BsEnMoistureConditionValueWorksheet };
export default BsEnMoistureConditionValueWorksheet;
